import * as authEndpoints from './auth';
import * as assetEndpoints from './assets';
import * as analyticsEndpoints from './analytics';
import * as cmsEndpoints from './cms';
import * as companyEndpoints from './company';
import * as deviceEndpoints from './devices';
import * as inviteEndpoints from './invites';
import * as licenseEnpoints from './license';
import * as mappingsEndpoints from './mappings';
import * as queryEndpoints from './query';
import * as reportEndpoints from './reports';
import * as siteGroupEndpoints from './sitegroups';
import * as siteEndpoints from './sites';
import * as templateEndpoints from './template';
import * as userEndpoints from './users';
import * as widgetsEndpoints from './widgets';
import * as notificationsEndpoints from './notifications';
import * as presetsEndpoints from './presets';
import * as campaignEndpoints from './campaign';
import * as portalsEndpoints from './portals';
import * as posReportsEndpoints from './pointOfSales';
import * as webPropertiesEndpoints from './webProperties';
import * as storeAttributionEndpoints from './storeAttribution';
import * as apiKeyEndpoints from './apiKeys';

export default {
  ...authEndpoints,
  ...assetEndpoints,
  ...analyticsEndpoints,
  ...cmsEndpoints,
  ...companyEndpoints,
  ...deviceEndpoints,
  ...inviteEndpoints,
  ...licenseEnpoints,
  ...mappingsEndpoints,
  ...queryEndpoints,
  ...reportEndpoints,
  ...siteGroupEndpoints,
  ...siteEndpoints,
  ...templateEndpoints,
  ...userEndpoints,
  ...widgetsEndpoints,
  ...notificationsEndpoints,
  ...presetsEndpoints,
  ...campaignEndpoints,
  ...portalsEndpoints,
  ...posReportsEndpoints,
  ...webPropertiesEndpoints,
  ...apiKeyEndpoints,
  ...storeAttributionEndpoints
};
